import studentNoSubComponent from './nosub.component';


export default angular
  .module('fizyweb.paycell.student.nosub', [])
  .component('nosub', studentNoSubComponent).name;



// WEBPACK FOOTER //
// src/app/components/student/nosub/nosub.module.ts